/* eslint jsx-a11y/aria-role: 0 */
import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import {
  checkOutUri,
  rootPageUri,
  ordersUri,
  myaccountUri,
  suggestionsUri,
  filterOldUri,
  thankYouUri,
  failureUri,
} from '../../config/uri';
import { isSearchPage } from '../../helpers/urlParts';
import CartCounter from '../CartCounter';
import { ECOMMERCE } from '../../config/global';
import {
  LogoutIcon,
  OrdersIcon,
} from '../../icons/menu';
import AccountIcon from '../../icons/AccountIcon';
import LoginIcon from '../../icons/LoginIcon';
import RefineIcon from '../../icons/RefineIcon';
import LocationIcon from '../../icons/LocationIcon';
import UsageLimits from '../../icons/UsageLimits';
import './cart.css';
import './navbar.css';
import { getIconStyle } from '../../icons/icon_utils';
import SearchBar from '../Search/SearchBar';
import FilterIcon from '../../icons/FilterIcon';
import GridIcon from '../../icons/GridIcon';
import ListIcon from '../../icons/ListIcon';
import LayoutType from '../../const/layout_type';
import CustomerTypeDropdown from '../CustomerTypeDropdown';
import { WHITE } from '../../config/colors';
import { confirmResetCartModal } from '../../helpers/cartHelper';
import { SAME_SALES_CHANNEL_MESSAGE } from '../../const/cart_const';

const styles = {
  customerWrapper: {
    margin: '0 15px',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: '40px',
    width: 'auto',
    cursor: 'pointer',
  },
  customerName: {
    color: WHITE,
    display: 'flex',
    alignItems: 'center',
    margin: '0 15px',
  },
  customerImage: {
    display: 'block',
  },
  loginBtn: {
    height: '35px',
    cursor: 'pointer',
  },
  locationBtn: {
    width: '30px',
    height: '30px',
    cursor: 'pointer',
    margin: '0 1px 2px 0',
    padding: '0 3px 9px',
  },
  cart: { width: 'auto', height: '100%' },
  filter: { width: 'auto', height: '100%' },
  refineIcon: { width: 'auto', height: '50px' },
  purchaseLimitIcon: { width: 'auto', height: '26px' },
  logoutIcon: { width: 'auto', height: '100%' },
  ordersIcon: { width: 'auto', height: '100%' },
  locationIcon: { width: 'auto', height: '37px' },
  refineContainer: { marginRight: 18 },
};

class NavBar extends Component {
  getLogoStyle = () => {
    const {
      isPhone,
    } = this.props;

    if (isPhone) {
      return { ...styles.logo, height: '40px' };
    }

    return styles.logo;
  }

  getDefaultLogoStyle = () => {
    const {
      isPhone,
    } = this.props;

    if (isPhone) {
      return { ...styles.logo, height: '30px', marginTop: '4px' };
    }

    return { ...styles.logo, marginTop: '4px' };
  }

  handleRefineClick = () => {
    this.props.go(suggestionsUri);
  }

  handleOldRefineClick = () => {
    this.props.go(filterOldUri);
  }

  handleMenuClick = () => {
    const {
      isMenuOpen,
      hideMenu,
      openMenu,
    } = this.props;

    if (isMenuOpen) {
      hideMenu();
      return;
    }

    openMenu();
  }

  handleCartClick = () => {
    const {
      router,
      isOnlineMenu,
      isMenuOpen,
      hideMenu,
      showCart,
      isUser,
    } = this.props;

    if (router.location.pathname === checkOutUri) {
      this.props.go(rootPageUri);
    } else if (isOnlineMenu&& isUser && isUser && !this.props.currentAddress) {

      if (this.props.isSalesChannelNameItemMismatch) {
        this.props.openConfirmModal(  
          confirmResetCartModal(
            () => {
              this.props.resetCart();
              this.props.openShippingForm({ handleClose: this.props.showCart });
            },
            SAME_SALES_CHANNEL_MESSAGE
          )
        );
        return;
      }
      this.props.openShippingForm({ handleClose: this.props.showCart });
    } else {
      if (isMenuOpen) {
        hideMenu();
      }
      showCart();
    }
  }

  handleLocationClick = () => {
    this.props.openShippingForm();
  }

  isFilterBtn = () => {
    if (this.props.isMenuOpen) {
      return false;
    }
    if (!this.props.isSearch) {
      return false;
    }
    const path = this.props.router.location.pathname;
    return isSearchPage(path);
  }

  isCartPage = () => {
    const { router } = this.props;

    return router.location.pathname.indexOf(checkOutUri) > -1;
  };

  isThankYouOrFailurePage = () => {
    const { router } = this.props;
    const { location: {pathname} } = router;
    
    return pathname.indexOf(thankYouUri) > -1 || pathname.indexOf(failureUri) > -1;
  }

  isSearchOpen = () => {
    const path = this.props.router.location.pathname;

    return path.indexOf('/filter') !== -1;
  }

  handleTreezClick = () => {
    const {
      logoUrlLink,
      isMenuOpen,
      hideMenu,
    } = this.props;

    if (logoUrlLink && logoUrlLink.trim() !== '') {
      window.location.href = logoUrlLink;
      return;
    }
    if (isMenuOpen) {
      hideMenu();
    }

    this.props.mainPageClick();
  }

  handleAccountClick = () => {
    this.props.go(myaccountUri);
  }

  getHeaderStyle = () => {
    return { background: '#' + this.props.primaryColor, display: this.props.config.configFetched ? '' : 'none' }
  }

  isBackBtn = () => {
    return this.props.isBackBtnActive && !this.props.isMenuOpen;
  }

  renderUpdated() {
    if (!this.props.updated) return null;
    return (<div className="updated">&nbsp;</div>);
  }

  renderLogo() {
    const { logo, isPaymentKiosk } = this.props;

    if (isPaymentKiosk) {
      return (<ReactSVG style={{ height: '90px', color: WHITE, marginTop: '5px' }} path={require('./icons/logo.svg')} role="logo" alt="Treez.io" />);
    }

    if (logo) {
      return (<img alt="logo" style={this.getLogoStyle()} src={logo} />);
    }

    return (<ReactSVG style={this.getDefaultLogoStyle()} path={require('./icons/logo-grey.svg')} role="logo" alt="Treez.io" />);
  }

  isLocationIcon = () => !this.isCartPage();

  isSearchBar = () => !this.props.isPhone && !this.isCartPage() && !this.isThankYouOrFailurePage();

  isFilterIcon = () => !this.isCartPage() && !this.isThankYouOrFailurePage();

  isRefineIcon = () => !this.isCartPage();

  isLayoutTypeIcon = () => !this.isCartPage();

  isCart = () => {
    const { isCart, isMainBoard } = this.props;
    return isCart && !isMainBoard;
  }

  isPurchaseLimits = () => {
    const {
      isPurchaseRestrictions,
    } = this.props;

    return this.isCartPage() ;
  }

  isSandwich = () => {
    const { isMainBoard, isPaymentKiosk } = this.props;
    return !isPaymentKiosk && !isMainBoard;
  }

  isEcommerceSearchBarEnabled = () => this.props.isEcommerceSearchBarEnabled;

  isOverLimits = () => {
    const {
      isPurchaseLimitsExceeded,
      isUser,
      isKioskCustomer,
    } = this.props;

    return this.isPurchaseLimits()
            && ECOMMERCE
            && (isUser || isKioskCustomer)
            && isPurchaseLimitsExceeded;
  }

  handleUsageLimits = () => {
    this.props.openPurchaseLimitsForm();
  }

  handleLogOutClick = () => {
    this.props.openLogOutForm({
      onClose: this.openMainPage
    });
  }

  openMainPage = () => {
    this.props.go(rootPageUri);
  };

  handleOrdersClick = () => {
    const { isUser } = this.props;

    if (!isUser) {
      this.props.setHandleOrdersAfterLogin(true);

      this.props.openLoginForm();
    }
    else {
      this.props.go(ordersUri);
    }
  }

  getCartIconColor = () => {
    return `#${this.props.cartIconColor}`;
  }

  renderLayoutTypeIcon = () => {
    const {
      isPhone,
      layoutType,
    } = this.props;

    return layoutType === LayoutType.GRID
      ? <GridIcon color={`#${this.props.searchIconColor}`} style={getIconStyle('grid', isPhone)} />
      : <ListIcon color={`#${this.props.searchIconColor}`} style={getIconStyle('list', isPhone)} />;
  }

  render() {
    const {
      isPaymentKiosk,
      openLoginForm,
      isPhone,
      isUser,
      isCustomerTypeOptionEnabled,
      rewardsDollars,
      allowRewardsRedemptionEcommerce
    } = this.props;

    const isBackBtn = this.isBackBtn();
    const headerClass = 'header primary ' + (isPaymentKiosk ? ' payment-kiosk' : '');
    const backBtnWrapperClass = isPaymentKiosk ? "back-btn-wrapper payment-kiosk fade-in " : "back-btn-wrapper fade-in ";

    return (
      <div>
        <div className={headerClass} style={this.getHeaderStyle()}>
          <div className="left">
            {/* Back button begin */}
            <div onClick={this.props.onBackBtnClick} className={backBtnWrapperClass + (isBackBtn ? '' : 'hide')}>
              <div className="back-btn-padding step-back"></div>
              <div className="main-category fade-in one"><ReactSVG style={{ fill: '#616161' }} path={require('./icons/go-back-left-arrow.svg')} role="logo" alt="go_back" /></div>
            </div>

            {/* Back button end */}
            {this.isSandwich() &&
              <span role="menu" onClick={this.handleMenuClick} style={{ height: '35px' }}>
                <ReactSVG
                  style={{ fill: `#${this.props.hamburgerIconColor}`, height: '35px', width: '35px', cursor: 'pointer' }}
                  path={require('./icons/menu_grey.svg')}
                  className="menu-icon"
                  alt="Menu"
                />
              </span>
            }

            <div onClick={this.handleTreezClick} className="logo">{this.renderLogo()}</div>
          </div>

          {isPaymentKiosk && !this.props.isUser &&
            <div className="middle">
              <button onClick={this.handleOrdersClick} className="payment-kiosk-find-order">
                <OrdersIcon color={`#${this.props.cartIconColor}`} style={styles.ordersIcon} /> Find my online order
              </button>
            </div>
          }

          <div role="searchbar" className="right searchbar">
            {this.isEcommerceSearchBarEnabled()
            && this.isSearchBar()
            && (
              <SearchBar
                className="hidden-mobile right-nav-item"
                style={styles.refineContainer}
              />
            )}
            {!isPhone && !this.props.isUser &&
              <div role="login" onClick={openLoginForm} className="welcome-container right-nav-item">
                <LoginIcon style={{height: "25px", width: 'auto'}} color={this.getCartIconColor()} />
                <span className="welcome-wrapper">&nbsp;&nbsp;Login/Sign Up</span>
              </div>
            }

            {!isPhone && this.props.isUser &&
              <div role="account info" onClick={this.handleAccountClick} className="welcome-container">
                <AccountIcon style={{height: "25px", width: 'auto'}} color={this.getCartIconColor()} />
                <span className="welcome-wrapper">
                  &nbsp;&nbsp;Welcome {this.props.userFirstName}!
                </span>
              </div>
            }
            <div className="navbar-inner-right-container">
            {
              isUser && allowRewardsRedemptionEcommerce &&
              <span className="welcome-wrapper" style={
                isPhone
                  ? {
                      marginLeft: 6,
                      marginRight: 6,
                      minWidth: 0,
                      fontSize: 12
                  }
                  : {
                      marginRight: 18
                  }
                }>
                Rewards {rewardsDollars.formatMoney()}
              </span>
            }
            {isCustomerTypeOptionEnabled &&
              <div className="welcome-container right-nav-item">
                <CustomerTypeDropdown />
              </div>
            }
            {isPaymentKiosk && this.props.isUser &&
                <div role="logout" className="right-nav-item" onClick={this.handleLogOutClick}>
                  <LogoutIcon color={`#${this.props.hamburgerIconColor}`} style={styles.logoutIcon} />
                </div>
              }

              {this.isEcommerceSearchBarEnabled()
                && isPhone
                && this.isLayoutTypeIcon()
                && (
                  <div className="visible-mobile right-nav-item" role="view-type" onClick={this.props.flipLayout}>
                    {this.renderLayoutTypeIcon()}
                  </div>
                )
              }

              {this.isEcommerceSearchBarEnabled()
                && this.isRefineIcon()
                && (
                  <div role="refine" className="visible-mobile right-nav-item" onClick={this.handleRefineClick}>
                    <RefineIcon color={`#${this.props.searchIconColor}`} style={getIconStyle('refine', isPhone)} />
                  </div>
                )
              }

              {!this.isEcommerceSearchBarEnabled()
                && this.isRefineIcon()
                && (
                  <div role="refine" className="right-nav-item" onClick={this.handleOldRefineClick}>
                    <RefineIcon color={`#${this.props.searchIconColor}`} style={getIconStyle('refine', isPhone)} />
                  </div>
                )
              }

              {this.isEcommerceSearchBarEnabled()
              && this.isFilterIcon()
              && (
                <div className="right-nav-item" role="filter" onClick={this.props.openCloseAdvancedFilter}>
                  <FilterIcon
                    style={getIconStyle('filter', isPhone)}
                    color={`#${this.props.cartIconColor}`}
                    viewBox={'0 0 20 20'}
                  />
                </div>
              )}

              {this.isLocationIcon()
                && (
                  <div className="right-nav-item" role="location" onClick={this.handleLocationClick}>
                    <LocationIcon color={this.getCartIconColor()} style={getIconStyle('location', isPhone)} />
                  </div>
                )
              }

              {isPaymentKiosk && this.props.isUser &&
                <div className="right-nav-item" onClick={this.handleOrdersClick}>
                  <OrdersIcon color={`#${this.props.cartIconColor}`} style={getIconStyle('orders', isPhone)} />
                </div>
              }

              {this.isPurchaseLimits() && ECOMMERCE && (this.props.isUser || this.props.isKioskCustomer) &&
                <div className="right-nav-item" onClick={this.handleUsageLimits}>
                  <UsageLimits color={`#${this.props.purchaseLimitsIconColor}`} style={styles.purchaseLimitIcon} />
                </div>
              }

              {this.isCart() && ECOMMERCE &&
                <div role="cart" onClick={this.handleCartClick}>
                  <CartCounter
                    cartIconStyle={getIconStyle('cart', isPhone)}
                    isOverLimits={this.isOverLimits()}
                    color={this.getCartIconColor()}
                    cartQuantity={this.props.cartQuantity}
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.jsx